import React, { SVGProps } from 'react';

export const ChartIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 56,
  height = 52,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 56 52"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49 51H55L55 16H49L49 51Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M37 51H43V27H37V51Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M25 51H31L31 34H25V51Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M13 51H19V38H13L13 51Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M1 51H7L7 40H1L1 51Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M2.22998 33.25C22 36 46 23 48 6"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M44 5.98L52 6.02L48.02 1L44 5.98Z"
        stroke="#DC342D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
